// src/ui/ThemeSwitcher.js
// Theme selector: renders color-swatch dots, persists selection in a cookie.
// Each theme is a CSS class on <html> matching one of the .theme-* rules in styles.css.

import { setCookie, getCookie } from '../cookie.js';

const STORAGE_KEY = 'helix.theme';
const DEFAULT_THEME = 'midnight';

const THEMES = [
  { id: 'midnight',    label: 'Midnight',     color: '#ff5252' },
  { id: 'aurora',      label: 'Aurora',       color: '#00f0ff' },
  { id: 'warm-studio', label: 'Warm Studio',  color: '#d4a050' },
  { id: 'oceanside',   label: 'Oceanside',    color: '#40c8b0' },
  { id: 'retro-wave',  label: 'Retro Wave',   color: '#ff00c8' },
  { id: 'royal',       label: 'Royal',        color: '#b088f0' },
  { id: 'paper',       label: 'Paper',        color: '#d45050' }
];

function loadTheme() {
  try { return getCookie(STORAGE_KEY) || DEFAULT_THEME; }
  catch { return DEFAULT_THEME; }
}

export function applyTheme(id) {
  const theme = id || DEFAULT_THEME;
  document.documentElement.className = theme === DEFAULT_THEME ? '' : `theme-${theme}`;
}

export function initTheme() {
  const saved = loadTheme();
  applyTheme(saved);
  return saved;
}

export class ThemeSwitcher {
  constructor(rootEl) {
    this.root = rootEl;
    this.render();
  }

  render() {
    const current = loadTheme();
    this.root.innerHTML = THEMES.map(t => `
      <button class="theme-swatch${t.id === current ? ' active' : ''}"
              data-theme="${t.id}"
              title="${t.label}"
              style="--swatch-color: ${t.color}">
        <span class="theme-swatch-dot"></span>
      </button>
    `).join('');

    this.root.addEventListener('click', (e) => {
      const btn = e.target.closest('.theme-swatch');
      if (!btn) return;
      const id = btn.dataset.theme;
      if (!id) return;

      applyTheme(id);
      try { setCookie(STORAGE_KEY, id); } catch { /* noop */ }

      // Update active state
      this.root.querySelectorAll('.theme-swatch').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  }
}
